module.exports = __webpack_public_path__ + "img/poland.0fe12d20.svg";